<!-- <h1 class="h3 mb-3">Contract Summary Results</h1> -->

<div class="search-results">
  <p class="nav-back">
    <a class="nav-back__link" routerLink="/contract-summary-search">Back to Search</a>
  </p>
  <div class="card">
    <div class="card__section">
      <div class="row align-bottom">
        <div class="columns">
          <!-- <h1 class="typography--display1">Summary</h1> -->
          <h1 class="card__title card__title--large">Contract Summary</h1>
        </div>
        <div class="columns shrink">
          <button class="btn btn--hollow btn--tiny" type="button" (click)="onDownloadAll()">Download All</button>
        </div>
      </div>
    </div>
    <div class="card__section">
      <div class="display-options">
        <div class="display-options__count">
          Showing {{ (searchResultsState$ | async).pagingSorting.pageSize * ((searchResultsState$ | async).pagingSorting.currentPage - 1) + 1 }} -
          {{
            (searchResultsState$ | async).pagingSorting.pageSize > (searchResultsState$ | async).pagingSorting.totalCount
              ? (searchResultsState$ | async).pagingSorting.totalCount
              : (searchResultsState$ | async).pagingSorting.pageSize * (searchResultsState$ | async).pagingSorting.currentPage
          }}
          of
          {{ (searchResultsState$ | async).pagingSorting.totalCount }}
        </div>
        <label class="display-options__per-page">
          Show
          <select (change)="setPageSize($event.target.value)">
            <option value="15" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 15">15</option>
            <option value="25" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 25">25</option>
            <option value="50" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 50">50</option>
            <option value="100" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 100">100</option>
            <option value="200" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 200">200</option>
          </select>
        </label>
        <!--<input type="text" class="display-options__filter" placeholder="Type to filter..." aria-label="Type to filter">-->
        <div class="display-options__filter"></div>
        <div class="display-options__pagination">
          <ul class="pagination" role="navigation" aria-label="Pagination">
            <!--<li class="pagination__previous disabled">Previous<span class="show-for-sr"> page</span></li>-->
            <li class="pagination__previous" [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage <= 1">
              {{ (searchResultsState$ | async).pagingSorting.currentPage <= 1 ? 'Previous' : '' }}
              <a *ngIf="(searchResultsState$ | async).pagingSorting.currentPage > 1" aria-label="Previous page" (click)="prevPage()"
                >Previous<span class="show-for-sr"> page</span></a
              >
            </li>
            <li class="pagination__current">
              <span class="show-for-sr">You are on page </span>
              {{ (searchResultsState$ | async).pagingSorting.currentPage }}
            </li>
            <li aria-hidden="true">of</li>
            <li>
              <a aria-label="Page 10" (click)="lastPage()">{{ (searchResultsState$ | async).pagingSorting.totalPages }}</a>
            </li>
            <li
              class="pagination__next"
              [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages"
            >
              {{ (searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages ? 'Next' : '' }}
              <a
                *ngIf="(searchResultsState$ | async).pagingSorting.currentPage < (searchResultsState$ | async).pagingSorting.totalPages"
                aria-label="Next page"
                (click)="nextPage()"
                >Next<span class="show-for-sr"> page</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="full-page-spinner" [class.full-page-spinner--is-active]="(searchResultsState$ | async).loading || (downloadRequestFormState$ | async).loading">
      <div class="full-page-spinner__icon"></div>
    </div>

    <div class="card__section">
      <div class="table" role="table">
        <div role="rowgroup">
          <div class="table__row table__row--header" role="row">
            <span class="table__cell table__cell--align-left table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('CreatedDateTime')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreatedDateTime' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreatedDateTime' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Date
              </button>
            </span>
            <span class="table__cell" role="columnheader">
              <button
                class="table__sorter-btn table__sorter-btn--sorted-asc"
                (click)="sortBy('ContractNumber')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ContractNumber' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ContractNumber' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Contract Number
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('ContractFileFound')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ContractFileFound' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ContractFileFound' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                File Found
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('EffectiveFrom')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'EffectiveFrom' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'EffectiveFrom' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Effective From
              </button>
            </span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="columnheader" title="Social Security Number">
              <button
                class="table__sorter-btn"
                (click)="sortBy('OrderId')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'OrderId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'OrderId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Order Id
              </button>
            </span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('ContractId')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ContractId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'ContractId' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Contract Id
              </button>
            </span>
            <span class="table__cell table__cell--quarter" role="columnheader"></span>
            <span class="table__cell table__cell--quarter" role="columnheader"></span>
          </div>
        </div>
        <div role="rowgroup">
          <a
            class="table__row ng-scope"
            role="row"
            *ngFor="let contract of (searchResultsState$ | async).response?.results; odd as isOdd; last as isLast"
            [class.table__row--alt]="isOdd"
            [class.table__row--last]="isLast"
          >
            <span class="table__cell table__cell--align-left table__cell--half" role="cell" [title]="contract.createdDate | date : 'MM/dd/yyyy hh:mm:ss a'">
              {{ contract.createdDate | date : 'MM/dd/yyyy hh:mm:ss a' }}
            </span>
            <span class="table__cell" role="cell">{{ contract.contractNumber }}</span>
            <span class="table__cell table__cell--half" role="cell">{{ contract.contractFileFound ? 'Yes' : 'No' }}</span>
            <span class="table__cell table__cell--half" role="cell">{{ contract.effectiveDate | date : 'MM/dd/yyyy hh:mm:ss a' }}</span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="cell">{{ contract.orderId }}</span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="cell">{{ contract.id }}</span>
            <span class="table__cell table__cell--quarter" role="cell">
              <button class="btn btn--hollow btn--tiny" (click)="downloadContract(contract.orderId)" *ngIf="contract.contractFileFound">
                <span class="icon icon--download"></span>
              </button>
            </span>
            <span class="table__cell table__cell--quarter" role="cell">
              <button
                class="btn btn--hollow btn--tiny copy-btn"
                (click)="copyLink(contract)"
                [class.copied]="contract.isCopied"
                [attr.aria-label]="contract.isCopied ? 'Copied!' : 'Copy link'"
                *ngIf="contract.contractFileFound"
              >
                <span class="icon" [class.icon--copy]="!contract.isCopied" [class.icon--check]="contract.isCopied"></span>

                <!-- Tooltip Popup -->
                <span class="copy-tooltip" [class.show]="contract.isCopied"> Copied! </span>
              </button>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div class="card__section">
      <div class="display-options">
        <div class="display-options__count">
          Showing {{ (searchResultsState$ | async).pagingSorting.pageSize * ((searchResultsState$ | async).pagingSorting.currentPage - 1) + 1 }} -
          {{
            (searchResultsState$ | async).pagingSorting.pageSize > (searchResultsState$ | async).pagingSorting.totalCount
              ? (searchResultsState$ | async).pagingSorting.totalCount
              : (searchResultsState$ | async).pagingSorting.pageSize * (searchResultsState$ | async).pagingSorting.currentPage
          }}
          of
          {{ (searchResultsState$ | async).pagingSorting.totalCount }}
        </div>
        <label class="display-options__per-page">
          Show
          <select (change)="setPageSize($event.target.value)">
            <option value="15" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 15">15</option>
            <option value="25" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 25">25</option>
            <option value="50" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 50">50</option>
            <option value="100" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 100">100</option>
            <option value="200" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 200">200</option>
          </select>
        </label>
        <!--<input type="text" class="display-options__filter" placeholder="Type to filter..." aria-label="Type to filter">-->
        <div class="display-options__filter"></div>
        <div class="display-options__pagination">
          <ul class="pagination" role="navigation" aria-label="Pagination">
            <!--<li class="pagination__previous disabled">Previous<span class="show-for-sr"> page</span></li>-->
            <li class="pagination__previous" [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage <= 1">
              {{ (searchResultsState$ | async).pagingSorting.currentPage <= 1 ? 'Previous' : '' }}
              <a *ngIf="(searchResultsState$ | async).pagingSorting.currentPage > 1" aria-label="Previous page" (click)="prevPage()"
                >Previous<span class="show-for-sr"> page</span></a
              >
            </li>
            <li class="pagination__current">
              <span class="show-for-sr">You are on page </span>
              {{ (searchResultsState$ | async).pagingSorting.currentPage }}
            </li>
            <li aria-hidden="true">of</li>
            <li>
              <a aria-label="Page 10" (click)="lastPage()">{{ (searchResultsState$ | async).pagingSorting.totalPages }}</a>
            </li>
            <li
              class="pagination__next"
              [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages"
            >
              {{ (searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages ? 'Next' : '' }}
              <a
                *ngIf="(searchResultsState$ | async).pagingSorting.currentPage < (searchResultsState$ | async).pagingSorting.totalPages"
                aria-label="Next page"
                (click)="nextPage()"
                >Next<span class="show-for-sr"> page</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
